// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddPayoutFailure-errorMessage-boTMb {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.AddPayoutFailure-space1-n81Df {
	margin-bottom: 6px !important;
}
.AddPayoutFailure-space2-Q9vXy {
	margin-bottom: 12px !important;
}
.AddPayoutFailure-space3-RoklX {
	margin-bottom: 18px !important;
}
.AddPayoutFailure-space4-KcPE0 {
	margin-bottom: 24px !important;
}
.AddPayoutFailure-space5-CMipt {
	margin-bottom: 30px !important;
}
.AddPayoutFailure-space6-Ya41c {
	margin-bottom: 36px !important;
}
.AddPayoutFailure-space7-e84ab {
	margin-bottom: 42px !important;
}
.AddPayoutFailure-spaceTop8-erzgE {
	margin-bottom: 48px !important;
}
.AddPayoutFailure-spaceTop1-RvsW9 {
	margin-top: 6px !important;
}
.AddPayoutFailure-spaceTop2-Y_Zt9 {
	margin-top: 12px !important;
}
.AddPayoutFailure-spaceTop3-NAjXe {
	margin-top: 18px !important;
}
.AddPayoutFailure-spaceTop4-JLFdl {
	margin-top: 24px !important;
}
.AddPayoutFailure-spaceTop5-QFdXG {
	margin-top: 30px !important;
}
.AddPayoutFailure-spaceTop6-y2CWj {
	margin-top: 36px !important;
}
.AddPayoutFailure-spaceTop7-_Zk8i {
	margin-top: 42px !important;
}
.AddPayoutFailure-spaceTop8-erzgE {
	margin-top: 48px !important;
}
.AddPayoutFailure-noMargin-sk_0w {
	margin: 0px !important;
}
.AddPayoutFailure-padding1-rqKVt {
	padding-bottom: 6px !important;
}
.AddPayoutFailure-padding2-uCPVk {
	padding-bottom: 12px !important;
}
.AddPayoutFailure-padding3-gxXM7 {
	padding-bottom: 18px !important;
}
.AddPayoutFailure-padding4-vJXD7 {
	padding-bottom: 24px !important;
}
.AddPayoutFailure-padding5-ad0kO {
	padding-bottom: 30px !important;
}
.AddPayoutFailure-padding6-SRYGZ {
	padding-bottom: 36px !important;
}
.AddPayoutFailure-padding7-GHpAC {
	padding-bottom: 42px !important;
}
.AddPayoutFailure-paddingTop1-C6oeT {
	padding-top: 6px !important;
}
.AddPayoutFailure-paddingTop2-bFwHd {
	padding-top: 12px !important;
}
.AddPayoutFailure-paddingTop3-WeHk7 {
	padding-top: 18px !important;
}
.AddPayoutFailure-paddingTop4-RiV9_ {
	padding-top: 24px !important;
}
.AddPayoutFailure-paddingTop5-htvDS {
	padding-top: 30px !important;
}
.AddPayoutFailure-paddingTop6-B9tUz {
	padding-top: 36px !important;
}
.AddPayoutFailure-paddingTop7-cQo0W {
	padding-top: 42px !important;
}
.AddPayoutFailure-noPadding-R8EgF {
	padding: 0px !important;
}
.AddPayoutFailure-textBold-RR6hf {
	font-weight: 500 !important;
}
.AddPayoutFailure-textBolder-e3Uuf {
	font-weight: 700 !important;
}
.AddPayoutFailure-textNormal-uuWpt {
	font-weight: normal !important;
}
.AddPayoutFailure-spaceBottom20-S8NJl {
	margin-bottom: 20px;
}
.AddPayoutFailure-spaceBottom10-ORUH7 {
	margin-bottom: 10px;
}
.AddPayoutFailure-marginNone-IFmk7 {
	margin: 0;
}
.AddPayoutFailure-spaceBottom15-SIISp {
	margin-bottom: 15px;
}
.AddPayoutFailure-marginTopNone-Tr7K6 {
	margin-top: 0;
}
.AddPayoutFailure-spaceTop11-Pfaiz {
	margin-top: 11px;
}
.AddPayoutFailure-spaceTop21-Yarx1 {
	margin-top: 21px;
}
.AddPayoutFailure-spaceTop20-EVwEp {
	margin-top: 20px;
}
.AddPayoutFailure-spaceTop10-Bwrru {
	margin-top: 10px;
}
/*New Design Text Colors */
.AddPayoutFailure-textDarkBlue-tfz9T {
	color: rgb(20, 39, 94) !important;
}
.AddPayoutFailure-textLightBlue-w00Jg {
	color: rgb(57, 87, 106) !important;
}
.AddPayoutFailure-textLightSandleGreen-XQtcA {
	color: rgb(76, 86, 41) !important;
}
.AddPayoutFailure-textLightBrown-nJa8V {
	color: rgb(115, 79, 33) !important;
}
.AddPayoutFailure-textMediumMaroon-zAMkJ {
	color: rgb(87, 37, 51) !important;
}
.AddPayoutFailure-textBrown-sKYhg {
	color: rgb(160, 47, 24) !important;
}
.AddPayoutFailure-textMaroon-EfGk7 {
	color: rgb(155, 49, 67) !important;
}
.AddPayoutFailure-textDarkBrown-YvZC9 {
	color: rgb(83, 18, 16) !important;
}
.AddPayoutFailure-textMediumBrown-Aygy8 {
	color: rgb(142, 28, 10) !important;
}
.AddPayoutFailure-textSkyBlue-rPj98 {
	color: rgb(37, 117, 141) !important;
}
.AddPayoutFailure-textGray-wkXWv {
	color: rgb(77, 65, 51) !important;
}
.AddPayoutFailure-btn-glATD,
.AddPayoutFailure-btn-glATD:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 6px 12px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
	background: var(--background-primary) !important;
	color: var(--primary-btn-foreground) !important;
}
.AddPayoutFailure-btn-glATD:hover {
	background: var(--primary-border) !important;
	outline: 0 !important;
}
.AddPayoutFailure-btnPrimary-lX8Qi,
.AddPayoutFailure-btnPrimary-lX8Qi:focus {
	border-color: var(--primary-bg) !important;
	background-color: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}
.AddPayoutFailure-btnPrimary-lX8Qi:hover {
	border-color: var(--primary-bg-hover) !important;
	background-color: var(--primary-bg-hover) !important;
	color: var(--primary-btn-foreground) !important;
}
.AddPayoutFailure-btnPrimaryBorder-I_lnL,
.AddPayoutFailure-btnPrimaryBorder-I_lnL:focus {
	border-color: var(--primary-bg) !important;
	color: var(--primary-bg) !important;
	background-color: var(--background-primary) !important;
}
.AddPayoutFailure-btnPrimaryBorder-I_lnL:hover {
	border-color: var(--primary-bg-hover) !important;
	color: var(--primary-bg-hover) !important;
	background-color: var(--background-primary) !important;
}
.AddPayoutFailure-btnLink-Ub3IS,
.AddPayoutFailure-btnLink-Ub3IS:focus,
.AddPayoutFailure-btnLink-Ub3IS:hover {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 0px !important;
	width: auto !important;
	outline: 0 !important;
	background: transparent !important;
	color: var(--primary-link-foreground) !important;
	font-weight: inherit;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.AddPayoutFailure-searchFilterPopover-ZmddX {
	position: absolute;
	top: 51px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	max-height: 65vh;
	visibility: visible;
	background: var(--background-primary);
	-webkit-box-shadow: 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: 0px 0px 10px var(--primary-box-shadow);
	border-radius: 14px;
}
.AddPayoutFailure-searchFilterPopoverFull-Z36Uw {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background-color: var(--modal-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.AddPayoutFailure-searchFilterPopoverOverlay-Ygd0L {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	visibility: visible;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
}
.AddPayoutFailure-dateFilterpopVerlayHeight-oIdgw {
	max-height: 100%;
}
.AddPayoutFailure-dateFilterpopVerlayContentHeight-C1yfh {
	min-height: 100% !important;
}
.AddPayoutFailure-searchFilterCloseIcon-fV_S9 {
	font-size: 30px;
	color: var(--secondary-foreground);
}
.AddPayoutFailure-searchFilterPopoverFooter-YUHkr {
	width: 100%;
	position: relative;
	line-height: 0;
}
.AddPayoutFailure-displayTable-t4CuL {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.AddPayoutFailure-displayTableRow-uxask {
	display: table-row;
	vertical-align: middle;
}
.AddPayoutFailure-displayTableCell-Sg56E {
	display: table-cell;
	vertical-align: middle;
}
.AddPayoutFailure-displayInlineBlock-xe1Jb {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.AddPayoutFailure-fullWidth-j6jlP {
	width: 100% !important;
}
.AddPayoutFailure-captionTitle-qGe8I {
	font-size: 16px;
	color: var(--primary-foreground);
}
.AddPayoutFailure-showTabletSection-fvgVg {
	display: none !important;
}
.AddPayoutFailure-blockRadioButton-DrTQk {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}
.AddPayoutFailure-jumboSelect-rBaTT {
	height: 58px !important;
	font-size: 16px !important;
	padding: 15px 47px 20px 20px !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 4px !important;
}
.AddPayoutFailure-jumboSelectPadding-jjZzq {
	padding: 15px 50px 20px 20px !important;
}
.AddPayoutFailure-commonBorder-fAAEm {
	border: 1px solid var(--primary-border) !important;
	color: var(--secondary-foreground) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 3px !important;
}
.AddPayoutFailure-textAignRight-FTrn4 {
	text-align: right;
}
.AddPayoutFailure-textAlignLeft-c97qA {
	text-align: left;
}
.AddPayoutFailure-textAignCenter-gAeoG {
	text-align: center;
}
.AddPayoutFailure-moreFilterTitle-Z3Y9H {
	font-size: 18px;
}
.AddPayoutFailure-dot-7TsVg {
	color: var(--secondary-foreground);
	font-size: 12px;
	margin-bottom: 0;
}
/*************************** Header Modal Start **********************/
.AddPayoutFailure-currencyAndLanguageGrid-ZttqT {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 30px;
}
.AddPayoutFailure-activeItem-Gyy0j {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 8px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
}
.AddPayoutFailure-activeItem-Gyy0j:hover,
.AddPayoutFailure-activeItem-Gyy0j:focus,
.AddPayoutFailure-activeItem-Gyy0j:active {
	background-color: var(--common-hover-bg);
	color: var(--primary-foreground);
}
.AddPayoutFailure-activeSection-SuNqy:first-child {
	background-color: var(--primary-gray-bg);
	color: var(--primary-foreground);
	border: 1px solid var(--secondary-bg);
	cursor: not-allowed;
}
.AddPayoutFailure-commonCloseModalBtn-CXtjA {
	position: absolute;
	cursor: pointer;
}
.AddPayoutFailure-searchIconCommon-qpf_S {
	margin-right: 3px;
	position: relative;
	top: -1px;
}
.AddPayoutFailure-loginLabel-WMo_T {
	font-size: 16px;
	margin-bottom: 10px;
	font-weight: 600;
}
@media screen and (max-width: 767px) {

	.AddPayoutFailure-dropdownOverflow-HM3k4 {
		white-space: break-spaces;
		text-align: left;
	}

	.AddPayoutFailure-currencyAndLanguageGrid-ZttqT {
		grid-template-columns: repeat(2, 1fr);
	}
}
@media (max-width:991px) and (min-width:768px) {
	.AddPayoutFailure-currencyAndLanguageGrid-ZttqT {
		grid-template-columns: repeat(4, 1fr);
	}
}
/*************************** Header Modal End **********************/
.AddPayoutFailure-capitalizeText-inrZP {
	text-transform: capitalize;
}
@media screen and (max-width: 767px) {
	.AddPayoutFailure-searchFilterPopoverHeader-UGAFB {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 24px;
		border-bottom: 1px solid var(--primary-border);
		background-color: var(--modal-bg);
		border-radius: 14px 14px 0 0;
	}
}
@media screen and (max-width: 768px) {
	.AddPayoutFailure-searchFilterPopoverFull-Z36Uw {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
		border-radius: 14px;
	}

	.AddPayoutFailure-searchFilterPopoverContent-RuB9M {
		height: 100%;
		min-height: 100vh;
		-webkit-overflow-scrolling: touch;
	}

	.AddPayoutFailure-showTabletSection-fvgVg {
		display: block !important;
	}

	.AddPayoutFailure-hideTabletSection-BrlMP {
		display: none !important;
	}
}
@media screen and (max-width: 767px) {
	.AddPayoutFailure-searchFilterPopoverFooter-YUHkr {
		position: relative !important;
	}
}
@media screen and (max-width: 350px) {
	.AddPayoutFailure-btnFontsize-W2C7b {
		font-size: 14px !important;
	}
}
@media (max-width: 360px) {
	.AddPayoutFailure-searchFilterCloseIcon-fV_S9 {
		font-size: 25px;
	}
}
@media (max-width: 993px) and (min-width: 769px) {
	.AddPayoutFailure-responsiveFontsize-pVvd2 {
		font-size: 14px;
	}
}
/*****************Apply Button Alignment Start **********************/
.AddPayoutFailure-applyBtnDesktop-xG3hS {
	text-align: right;
}
@media screen and (max-width: 991px) {
	.AddPayoutFailure-applyBtnDesktop-xG3hS {
		text-align: center;
	}

	.AddPayoutFailure-applyBtnDesktopRight-Ig3r6 {
		text-align: right !important;
	}

	.AddPayoutFailure-applyBtnDesktopNoPaddingRight-xbjnx {
		padding-right: 0px !important;
	}

}
/*****************Apply Button Alignment Start **********************/
.AddPayoutFailure-root-XnqK7 {
	padding-left: 20px;
	padding-right: 20px;
}
.AddPayoutFailure-container-JWSVr {
	margin: 0 auto;
	padding: 0 0 40px;
	max-width: var(--max-content-width);
}
.AddPayoutFailure-textJumbo-iYRBR {
	font-size: 50px;
	font-weight: bold;
	margin: 0;
}
.AddPayoutFailure-textMedium-NcuZh {
	font-size: 30px;
	font-weight: bold;
	margin: 0;
}
.AddPayoutFailure-textCenter-kjoB8 {
	text-align: center;
}
.AddPayoutFailure-subTitle-Ke360 {
	font-size: 15px;
	color: var(--primary-foreground);
}
.AddPayoutFailure-firstBtn-Zt3Xa,
.AddPayoutFailure-firstBtn-Zt3Xa:focus,
.AddPayoutFailure-firstBtn-Zt3Xa:hover,
.AddPayoutFailure-firstBtn-Zt3Xa:active {
	margin-right: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/routes/addPayoutFailure/AddPayoutFailure.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,4BAA4B;CAC5B,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,gDAAgD;CAChD,+CAA+C;AAChD;AAEA;CACC,4CAA4C;CAC5C,qBAAqB;AACtB;AAEA;;CAEC,0CAA0C;CAC1C,8CAA8C;CAC9C,+CAA+C;AAChD;AAEA;CACC,gDAAgD;CAChD,oDAAoD;CACpD,+CAA+C;AAChD;AAEA;;CAEC,0CAA0C;CAC1C,mCAAmC;CACnC,sDAAsD;AACvD;AAEA;CACC,gDAAgD;CAChD,yCAAyC;CACzC,sDAAsD;AACvD;AAEA;;;CAGC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,uBAAuB;CACvB,sBAAsB;CACtB,qBAAqB;CACrB,kCAAkC;CAClC,gDAAgD;CAChD,oBAAoB;CACpB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;CACnB,qCAAqC;CACrC,0DAAkD;SAAlD,kDAAkD;CAClD,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,iCAAiC;CACjC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,mBAAmB;CACnB,SAAS;CACT,iCAAiC;AAClC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;AAEA;CACC,uBAAuB;CACvB,0BAA0B;CAC1B,uCAAuC;CACvC,kDAAkD;CAClD,6BAA6B;AAC9B;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,kDAAkD;CAClD,6CAA6C;CAC7C,mCAA2B;SAA3B,2BAA2B;CAC3B,6BAA6B;AAC9B;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,gBAAgB;AACjB;AAEA,sEAAsE;AACtE;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;AAGA;;;CAGC,wCAAwC;CACxC,gCAAgC;AACjC;AAEA;CACC,wCAAwC;CACxC,gCAAgC;CAChC,qCAAqC;CACrC,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;;CAEC;EACC,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,qCAAqC;CACtC;AACD;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;AAEpE;CACC,0BAA0B;AAC3B;AAEA;CACC;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C,iCAAiC;EACjC,4BAA4B;CAC7B;AACD;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;CACpB;;CAEA;EACC,YAAY;EACZ,iBAAiB;EACjB,iCAAiC;CAClC;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;;AAED;AAEA,qEAAqE;ACxXrE;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,mCAAmC;AACpC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,SAAS;AACV;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,gCAAgC;AACjC;AAEA;;;;CAIC,6BAA6B;AAC9B","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 6px 12px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n\tbackground: var(--background-primary) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btn:hover {\n\tbackground: var(--primary-border) !important;\n\toutline: 0 !important;\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--primary-bg) !important;\n\tbackground-color: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tbackground-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-bg) !important;\n\tcolor: var(--primary-bg) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-bg-hover) !important;\n\tcolor: var(--primary-bg-hover) !important;\n\tbackground-color: var(--background-primary) !important;\n}\n\n.btnLink,\n.btnLink:focus,\n.btnLink:hover {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 0px !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: transparent !important;\n\tcolor: var(--primary-link-foreground) !important;\n\tfont-weight: inherit;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 51px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tmax-height: 65vh;\n\tvisibility: visible;\n\tbackground: var(--background-primary);\n\tbox-shadow: 0px 0px 10px var(--primary-box-shadow);\n\tborder-radius: 14px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground-color: var(--modal-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tvisibility: visible;\n\tbottom: 0;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.dateFilterpopVerlayHeight {\n\tmax-height: 100%;\n}\n\n.dateFilterpopVerlayContentHeight {\n\tmin-height: 100% !important;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--secondary-foreground);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 16px;\n\tcolor: var(--primary-foreground);\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.jumboSelect {\n\theight: 58px !important;\n\tfont-size: 16px !important;\n\tpadding: 15px 47px 20px 20px !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 4px !important;\n}\n\n.jumboSelectPadding {\n\tpadding: 15px 50px 20px 20px !important;\n}\n\n.commonBorder {\n\tborder: 1px solid var(--primary-border) !important;\n\tcolor: var(--secondary-foreground) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n}\n\n.textAignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAignCenter {\n\ttext-align: center;\n}\n\n.moreFilterTitle {\n\tfont-size: 18px;\n}\n\n.dot {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 12px;\n\tmargin-bottom: 0;\n}\n\n/*************************** Header Modal Start **********************/\n.currencyAndLanguageGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 30px;\n}\n\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 8px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n}\n\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-hover-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--primary-gray-bg);\n\tcolor: var(--primary-foreground);\n\tborder: 1px solid var(--secondary-bg);\n\tcursor: not-allowed;\n}\n\n.commonCloseModalBtn {\n\tposition: absolute;\n\tcursor: pointer;\n}\n\n.searchIconCommon {\n\tmargin-right: 3px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.loginLabel {\n\tfont-size: 16px;\n\tmargin-bottom: 10px;\n\tfont-weight: 600;\n}\n\n@media screen and (max-width: 767px) {\n\n\t.dropdownOverflow {\n\t\twhite-space: break-spaces;\n\t\ttext-align: left;\n\t}\n\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n@media (max-width:991px) and (min-width:768px) {\n\t.currencyAndLanguageGrid {\n\t\tgrid-template-columns: repeat(4, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 24px;\n\t\tborder-bottom: 1px solid var(--primary-border);\n\t\tbackground-color: var(--modal-bg);\n\t\tborder-radius: 14px 14px 0 0;\n\t}\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t\tborder-radius: 14px;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\theight: 100%;\n\t\tmin-height: 100vh;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 14px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n@media (max-width: 993px) and (min-width: 769px) {\n\t.responsiveFontsize {\n\t\tfont-size: 14px;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n\n}\n\n/*****************Apply Button Alignment Start **********************/","@import '../../components/common.css';\n@import '../../components/helpers.css';\n\n.root {\n\tpadding-left: 20px;\n\tpadding-right: 20px;\n}\n\n.container {\n\tmargin: 0 auto;\n\tpadding: 0 0 40px;\n\tmax-width: var(--max-content-width);\n}\n\n.textJumbo {\n\tfont-size: 50px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textMedium {\n\tfont-size: 30px;\n\tfont-weight: bold;\n\tmargin: 0;\n}\n\n.textCenter {\n\ttext-align: center;\n}\n\n.subTitle {\n\tfont-size: 15px;\n\tcolor: var(--primary-foreground);\n}\n\n.firstBtn,\n.firstBtn:focus,\n.firstBtn:hover,\n.firstBtn:active {\n\tmargin-right: 10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AddPayoutFailure-errorMessage-boTMb`,
	"space1": `AddPayoutFailure-space1-n81Df`,
	"space2": `AddPayoutFailure-space2-Q9vXy`,
	"space3": `AddPayoutFailure-space3-RoklX`,
	"space4": `AddPayoutFailure-space4-KcPE0`,
	"space5": `AddPayoutFailure-space5-CMipt`,
	"space6": `AddPayoutFailure-space6-Ya41c`,
	"space7": `AddPayoutFailure-space7-e84ab`,
	"spaceTop8": `AddPayoutFailure-spaceTop8-erzgE`,
	"spaceTop1": `AddPayoutFailure-spaceTop1-RvsW9`,
	"spaceTop2": `AddPayoutFailure-spaceTop2-Y_Zt9`,
	"spaceTop3": `AddPayoutFailure-spaceTop3-NAjXe`,
	"spaceTop4": `AddPayoutFailure-spaceTop4-JLFdl`,
	"spaceTop5": `AddPayoutFailure-spaceTop5-QFdXG`,
	"spaceTop6": `AddPayoutFailure-spaceTop6-y2CWj`,
	"spaceTop7": `AddPayoutFailure-spaceTop7-_Zk8i`,
	"noMargin": `AddPayoutFailure-noMargin-sk_0w`,
	"padding1": `AddPayoutFailure-padding1-rqKVt`,
	"padding2": `AddPayoutFailure-padding2-uCPVk`,
	"padding3": `AddPayoutFailure-padding3-gxXM7`,
	"padding4": `AddPayoutFailure-padding4-vJXD7`,
	"padding5": `AddPayoutFailure-padding5-ad0kO`,
	"padding6": `AddPayoutFailure-padding6-SRYGZ`,
	"padding7": `AddPayoutFailure-padding7-GHpAC`,
	"paddingTop1": `AddPayoutFailure-paddingTop1-C6oeT`,
	"paddingTop2": `AddPayoutFailure-paddingTop2-bFwHd`,
	"paddingTop3": `AddPayoutFailure-paddingTop3-WeHk7`,
	"paddingTop4": `AddPayoutFailure-paddingTop4-RiV9_`,
	"paddingTop5": `AddPayoutFailure-paddingTop5-htvDS`,
	"paddingTop6": `AddPayoutFailure-paddingTop6-B9tUz`,
	"paddingTop7": `AddPayoutFailure-paddingTop7-cQo0W`,
	"noPadding": `AddPayoutFailure-noPadding-R8EgF`,
	"textBold": `AddPayoutFailure-textBold-RR6hf`,
	"textBolder": `AddPayoutFailure-textBolder-e3Uuf`,
	"textNormal": `AddPayoutFailure-textNormal-uuWpt`,
	"spaceBottom20": `AddPayoutFailure-spaceBottom20-S8NJl`,
	"spaceBottom10": `AddPayoutFailure-spaceBottom10-ORUH7`,
	"marginNone": `AddPayoutFailure-marginNone-IFmk7`,
	"spaceBottom15": `AddPayoutFailure-spaceBottom15-SIISp`,
	"marginTopNone": `AddPayoutFailure-marginTopNone-Tr7K6`,
	"spaceTop11": `AddPayoutFailure-spaceTop11-Pfaiz`,
	"spaceTop21": `AddPayoutFailure-spaceTop21-Yarx1`,
	"spaceTop20": `AddPayoutFailure-spaceTop20-EVwEp`,
	"spaceTop10": `AddPayoutFailure-spaceTop10-Bwrru`,
	"textDarkBlue": `AddPayoutFailure-textDarkBlue-tfz9T`,
	"textLightBlue": `AddPayoutFailure-textLightBlue-w00Jg`,
	"textLightSandleGreen": `AddPayoutFailure-textLightSandleGreen-XQtcA`,
	"textLightBrown": `AddPayoutFailure-textLightBrown-nJa8V`,
	"textMediumMaroon": `AddPayoutFailure-textMediumMaroon-zAMkJ`,
	"textBrown": `AddPayoutFailure-textBrown-sKYhg`,
	"textMaroon": `AddPayoutFailure-textMaroon-EfGk7`,
	"textDarkBrown": `AddPayoutFailure-textDarkBrown-YvZC9`,
	"textMediumBrown": `AddPayoutFailure-textMediumBrown-Aygy8`,
	"textSkyBlue": `AddPayoutFailure-textSkyBlue-rPj98`,
	"textGray": `AddPayoutFailure-textGray-wkXWv`,
	"btn": `AddPayoutFailure-btn-glATD`,
	"btnPrimary": `AddPayoutFailure-btnPrimary-lX8Qi`,
	"btnPrimaryBorder": `AddPayoutFailure-btnPrimaryBorder-I_lnL`,
	"btnLink": `AddPayoutFailure-btnLink-Ub3IS`,
	"searchFilterPopover": `AddPayoutFailure-searchFilterPopover-ZmddX`,
	"searchFilterPopoverFull": `AddPayoutFailure-searchFilterPopoverFull-Z36Uw`,
	"searchFilterPopoverOverlay": `AddPayoutFailure-searchFilterPopoverOverlay-Ygd0L`,
	"dateFilterpopVerlayHeight": `AddPayoutFailure-dateFilterpopVerlayHeight-oIdgw`,
	"dateFilterpopVerlayContentHeight": `AddPayoutFailure-dateFilterpopVerlayContentHeight-C1yfh`,
	"searchFilterCloseIcon": `AddPayoutFailure-searchFilterCloseIcon-fV_S9`,
	"searchFilterPopoverFooter": `AddPayoutFailure-searchFilterPopoverFooter-YUHkr`,
	"displayTable": `AddPayoutFailure-displayTable-t4CuL`,
	"displayTableRow": `AddPayoutFailure-displayTableRow-uxask`,
	"displayTableCell": `AddPayoutFailure-displayTableCell-Sg56E`,
	"displayInlineBlock": `AddPayoutFailure-displayInlineBlock-xe1Jb`,
	"fullWidth": `AddPayoutFailure-fullWidth-j6jlP`,
	"captionTitle": `AddPayoutFailure-captionTitle-qGe8I`,
	"showTabletSection": `AddPayoutFailure-showTabletSection-fvgVg`,
	"blockRadioButton": `AddPayoutFailure-blockRadioButton-DrTQk`,
	"jumboSelect": `AddPayoutFailure-jumboSelect-rBaTT`,
	"jumboSelectPadding": `AddPayoutFailure-jumboSelectPadding-jjZzq`,
	"commonBorder": `AddPayoutFailure-commonBorder-fAAEm`,
	"textAignRight": `AddPayoutFailure-textAignRight-FTrn4`,
	"textAlignLeft": `AddPayoutFailure-textAlignLeft-c97qA`,
	"textAignCenter": `AddPayoutFailure-textAignCenter-gAeoG`,
	"moreFilterTitle": `AddPayoutFailure-moreFilterTitle-Z3Y9H`,
	"dot": `AddPayoutFailure-dot-7TsVg`,
	"currencyAndLanguageGrid": `AddPayoutFailure-currencyAndLanguageGrid-ZttqT`,
	"activeItem": `AddPayoutFailure-activeItem-Gyy0j`,
	"activeSection": `AddPayoutFailure-activeSection-SuNqy`,
	"commonCloseModalBtn": `AddPayoutFailure-commonCloseModalBtn-CXtjA`,
	"searchIconCommon": `AddPayoutFailure-searchIconCommon-qpf_S`,
	"loginLabel": `AddPayoutFailure-loginLabel-WMo_T`,
	"dropdownOverflow": `AddPayoutFailure-dropdownOverflow-HM3k4`,
	"capitalizeText": `AddPayoutFailure-capitalizeText-inrZP`,
	"searchFilterPopoverHeader": `AddPayoutFailure-searchFilterPopoverHeader-UGAFB`,
	"searchFilterPopoverContent": `AddPayoutFailure-searchFilterPopoverContent-RuB9M`,
	"hideTabletSection": `AddPayoutFailure-hideTabletSection-BrlMP`,
	"btnFontsize": `AddPayoutFailure-btnFontsize-W2C7b`,
	"responsiveFontsize": `AddPayoutFailure-responsiveFontsize-pVvd2`,
	"applyBtnDesktop": `AddPayoutFailure-applyBtnDesktop-xG3hS`,
	"applyBtnDesktopRight": `AddPayoutFailure-applyBtnDesktopRight-Ig3r6`,
	"applyBtnDesktopNoPaddingRight": `AddPayoutFailure-applyBtnDesktopNoPaddingRight-xbjnx`,
	"root": `AddPayoutFailure-root-XnqK7`,
	"container": `AddPayoutFailure-container-JWSVr`,
	"textJumbo": `AddPayoutFailure-textJumbo-iYRBR`,
	"textMedium": `AddPayoutFailure-textMedium-NcuZh`,
	"textCenter": `AddPayoutFailure-textCenter-kjoB8`,
	"subTitle": `AddPayoutFailure-subTitle-Ke360`,
	"firstBtn": `AddPayoutFailure-firstBtn-Zt3Xa`
};
module.exports = ___CSS_LOADER_EXPORT___;
